import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { NotificationState, StoreState } from "types/state/StoreState";
import { NewNotification, Notification } from "types/Notification";
import {
  createNotification,
  getNotifications
} from "services/api/notificationApi";
import { CommonRequest } from "types/common";
import { getPromotionApi } from "services/api/dashboardApi";
import { Promotion } from "types/Promotion";

const notificationSlice = createSlice({
  name: "notifications",
  initialState: {
    isLoading: false,
    notifications: [],
    promotions: []
  } as NotificationState,
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setNotifications(state, action) {
      state.notifications = action.payload;
    },
    setPromotions(state, action) {
      state.promotions = action.payload;
    }
  }
});
// Thunk Actions
export const getNotificationThunk = createAsyncThunk(
  "notification/getNotificationThunk",
  async (request: CommonRequest, thunkApi) => {
    const { dispatch } = thunkApi;
    const { accessToken, businessId } = request;
    dispatch(notificationSlice.actions.setIsLoading(true));
    const notification = await getNotifications(accessToken, businessId);
    dispatch(notificationSlice.actions.setNotifications(notification));
    dispatch(notificationSlice.actions.setIsLoading(false));
  }
);

type NewNotificationrRequest = {
  accessToken: string;
  businessId: string;
  newNotification: NewNotification;
};
export const createNotificationThunk = createAsyncThunk(
  "notification/createNotificationThunk",
  async (request: NewNotificationrRequest, thunkApi) => {
    const { dispatch } = thunkApi;
    const { newNotification, accessToken, businessId } = request;
    dispatch(notificationSlice.actions.setIsLoading(true));
    await createNotification(newNotification, accessToken, businessId);
    dispatch(notificationSlice.actions.setIsLoading(false));
  }
);

export const getPromotionThunk = createAsyncThunk(
  "notification/getPromotionThunk",
  async (request: CommonRequest, thunkApi) => {
    const { dispatch } = thunkApi;
    const { accessToken, businessId } = request;
    dispatch(notificationSlice.actions.setIsLoading(true));
    const promotions = await getPromotionApi(accessToken, businessId);
    dispatch(notificationSlice.actions.setPromotions(promotions));
    dispatch(notificationSlice.actions.setIsLoading(false));
  }
);

// Reducers
export const getLoadingStatus = (state: StoreState): boolean =>
  state.notifications.isLoading;
export const getAllNotifications = (state: StoreState): Notification[] =>
  state.notifications.notifications;

export const getAllPromotions = (state: StoreState): Promotion[] =>
  state.notifications.promotions;

export const { setNotifications, setIsLoading } = notificationSlice.actions;
export default notificationSlice.reducer;
